// import { useState } from 'react';

const CtaSection = () => {
    // const [formData, setFormData] = useState({
    //     name: '',
    //     email: '',
    //     company: 'Your Company*'
    // });

    // const handleChange = (e) => {
    //     setFormData({
    //         ...formData,
    //         [e.target.name]: e.target.value
    //     });
    // }

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    // }

    return (
        <section className="cta-section">
           
        </section>
    );
}

export default CtaSection;
